<div class="bcrmb">
  <div
    *ngFor="let case of cases; let i = index"
    class="bcrmb-container"
    [class]="getItemClass(case)"
  >
    <div class="bcrmb-divider" *ngIf="i > 0"></div>
    <img *ngIf="case.unreadCount == ChatStatus.MessageFromGp" alt="message" class="message" src="./../../../../assets/media/message.png" />
    <button type="button" class="bcrmb-node" (click)="onClickCase(case)">
      <div class="bcrmb-circle">{{ case.patientRecordCaseNumber }}</div>
      <div class="bcrmb-meta">
        <span class="bcrmb-label">{{ getTypeLabel(case) }}</span>
        <span class="bcrmb-sub" *ngIf="case.reviewType === 'AI' && case.tdsScore != null">
          TDS: {{ case.tdsScore }}
        </span>
        <span class="bcrmb-sub" *ngIf="case.reviewType === 'AI' && case.riskLevel">
          {{ case.riskLevel }}
        </span>
        <span class="bcrmb-sub" *ngIf="case.reviewType === 'AI' && case.recommendation">
          {{ case.recommendation }}
        </span>
        <span class="bcrmb-sub" *ngIf="case.reviewingDoctorName">
          {{ 'followUpHistoryReviewedBy' | translate:{ name: case.reviewingDoctorName } }}
        </span>
      </div>
    </button>
  </div>
</div>
